import { analyticsHelpers } from 'day8-ui';
import { updateSearch } from './querystring';
import { getSelectedCrew, getSelectedPackageData, getSelectedWeeks } from './week';

export const handleYachtSelection = (location, history, pathname, maxCapacity, destinations, week, packageData, openNewTab) => {
  const selectedCrew = getSelectedCrew(destinations, location);
  let girls = selectedCrew.girls;
  let boys = selectedCrew.boys;
  if (maxCapacity) {
    girls = Math.ceil(maxCapacity / 2);
    boys = maxCapacity - girls;
  }
  const selectedPackageData = packageData || getSelectedPackageData(destinations, location);
  const selectedWeeks = week ? [week] : getSelectedWeeks(destinations, location);
  const selectedWeek = selectedWeeks[0];
  analyticsHelpers.selectedCrew({
    week: selectedWeek.week,
    financial_year: selectedWeek.year,
    subject: 'yacht',
    package_name: selectedPackageData.name,
    destination_name: selectedWeek.destination.name,
    destination_id: selectedWeek.destination.id
  });
  const search = updateSearch(location, {
    girls,
    boys,
    dest: selectedWeek.destination.id,
    weeks: selectedWeek.week,
    year: selectedWeek.year,
    category: selectedPackageData.id
  });
  if (openNewTab) {
    window.open(`${pathname}?${search}`, '_blank', 'noopener,noreferrer');
    return;
  }
  history.push({
    pathname,
    search
  });
};

export const handleCabinSelection = (location, history, pathname, destinations, week = null, packageData, openNewTab) => {
  const selectedPackageData = packageData || getSelectedPackageData(destinations, location);
  const selectedWeeks = week ? [week] :getSelectedWeeks(destinations, location);
  const selectedWeek = selectedWeeks[0];
  analyticsHelpers.selectedCrew({
    week: selectedWeek.week,
    financial_year: selectedWeek.year,
    subject: 'cabin',
    package_name: selectedPackageData.name,
    destination_name: selectedWeek.destination.name,
    destination_id: selectedWeek.destination.id
  });
  const search = updateSearch(location, {
    dest: selectedWeek.destination.id,
    weeks: selectedWeek.week,
    year: selectedWeek.year,
    category: selectedPackageData.id
  });
  if (openNewTab) {
    window.open(`${pathname}?${search}`, '_blank', 'noopener,noreferrer');
    return;
  }
  history.push({
    pathname,
    search
  });
};
